import { AbstractMutableMapyktux9ubhc1g as AbstractMutableMap } from './AbstractMutableMap.mjs';
import { InternalHashMapmpvpylj0ut6l as InternalHashMap } from './InternalHashMap.mjs';
import {
  HashMapKeys28ggmxpft3hz9 as HashMapKeys,
  HashMapValues3umcxpfyfunqf as HashMapValues,
  HashMapEntrySet29p2ksc4wcy5i as HashMapEntrySet,
} from './HashMapEntry.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_HashMap(_this__u8e3s4) {
  _this__u8e3s4.l8_1 = null;
}
var HashMapClass;
function HashMap() {
  if (HashMapClass === VOID) {
    class $ extends AbstractMutableMap() {
      static m8(internalMap) {
        var $this = this.n7();
        init_kotlin_collections_HashMap($this);
        $this.k8_1 = internalMap;
        return $this;
      }
      static n8() {
        return this.m8(InternalHashMap().y8());
      }
      static z8(initialCapacity, loadFactor) {
        return this.m8(InternalHashMap().a9(initialCapacity, loadFactor));
      }
      static b9(initialCapacity) {
        return this.z8(initialCapacity, 1.0);
      }
      static c9(original) {
        return this.m8(InternalHashMap().d9(original));
      }
      v3() {
        this.k8_1.v3();
      }
      n3(key) {
        return this.k8_1.e9(key);
      }
      o3(value) {
        return this.k8_1.o3(value);
      }
      r7() {
        return HashMapKeys().g9(this.k8_1);
      }
      u7() {
        return HashMapValues().i9(this.k8_1);
      }
      d2() {
        var tmp0_elvis_lhs = this.l8_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = HashMapEntrySet().k9(this.k8_1);
          this.l8_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      p3(key) {
        return this.k8_1.p3(key);
      }
      s3(key, value) {
        return this.k8_1.s3(key, value);
      }
      t3(key) {
        return this.k8_1.t3(key);
      }
      p1() {
        return this.k8_1.p1();
      }
      u3(from) {
        return this.k8_1.u3(from);
      }
    }
    initMetadataForClass($, 'HashMap', $.n8, VOID, [AbstractMutableMap(), KtMutableMap()]);
    HashMapClass = $;
  }
  return HashMapClass;
}
//region block: exports
export {
  HashMap as HashMap1a0ld5kgwhmhv,
};
//endregion

//# sourceMappingURL=HashMap.mjs.map
